import React from 'react'

interface ContentCodeProps extends CommonProps {
  content: string
}

export const ContentCode = ({ testID, content }: ContentCodeProps) => (
  <div data-testid={testID}>{content}</div>
)
